import zh from '../../resources/locales/zh-TW.json';
export default {
  ...zh,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['zh-TW'],
};
